<template>
  <div class="hero">
    <div class="container">
      <div class="row">
        <div class="col-md-6 text-blog">
          <h2><strong>Thank You</strong></h2>
          <h5>
            I want to express my heartfelt thanks for making my Sweet 16 so special.
            The modeling shoot, web app development, hair, makeup, delicious food, and the
            lively atmosphere created by family and friends – it was all perfect!
            To everyone who contributed and celebrated with me, your presence made my day unforgettable.
            Thank you for being a part of my journey.
          </h5>
          <h5>
            #Blessed,<br />
            💖 Derriana "Tink" Smith
          </h5>
          <br />
          <b-row>
            <b-col cols="6" v-for="(aCredit, i) in credits" :key="`credit-${i}`"  style="margin-top: 5px">
              <h5>
                <strong>{{ aCredit.role }} </strong>
              </h5>
              <h6>
                {{ aCredit.name }}
                <b-link
                    v-if="aCredit.fb"
                    style="cursor:pointer;"
                    :href="`https://facebook.com/${aCredit.fb}`">
                  <b-icon
                      icon="facebook"
                      aria-hidden="true"
                  />
                </b-link>
                <b-link
                    v-if="aCredit.ig"
                    style="cursor:pointer;"
                    :href="`https://instagram.com/${aCredit.ig}`">
                  <b-icon
                      icon="instagram"
                      aria-hidden="true"
                  />
                </b-link>
              </h6>
            </b-col>
          </b-row>
          <button
            v-if="false"
            @click="handleGetStartedClick"
            class="btn btn-outline"
          >
            Join Us
          </button>
          <b-button
              v-if="false"
              pill
              style="background-color: #b2ac88"
              @click="handleToggleSidebar">
            <b-icon icon="pencil" font-scale="1"/>
            Leave a Message for Me
          </b-button>
        </div>
        <div class="col-md-6 img-blog">
          <video width="400" autoplay controls>
            <source
                src="/assets/_birthday/daddy2.mp4"
                type="video/mp4"
            >
            Your browser does not support HTML video.
          </video>
        </div>
      </div>
    </div>
    <b-sidebar
               :ref="sidebarId"
               :id="sidebarId"
               right
               width="80%"
               no-header
               shadow
    >
      <div class="px-3 py-2" style="background-color: #b2ac88; height: 100vh">
        <add-edit-form-blog
            v-if="false"
            @close-sidebar="handleToggleSidebar"
            @item-added="handleBlogAdded"
        />
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import AddEditFormBlog from "./addEditItemForm"
export default {
  name: "ThankYou_Hero",
  components:{
    AddEditFormBlog
  },
  methods: {
    handleGetStartedClick() {
      this.$router.push("/signup");
    },
    handleToggleSidebar() {
      this.$root.$emit('bv::toggle::collapse', this.sidebarId);
    },
    handleBlogAdded(){
      this.handleToggleSidebar();
      this.$emit("item-added");
    }
  },
  data() {
    return {
      sidebarId:'post-blog-sidebar',
      credits: [
        {
          role: "Stylist | Planner|  Director",
          ig:"whit_j87",
          name:"Cousin Whitney Cobb"
        },
        {
          role: "Natural Hair",
          ig:"quantre_love_hair",
          name:"Quantre Loveshair"
        },
        {
          role: "Make-Up",
          ig:"beatby_pooh",
          name:"Sherrea"
        },
        {
          role: "Photo Shoot Location",
          ig:"thecreatorscove",
          name:"CREATIVE CONTENT▪️EVENT STUDIO"
        },
        {
          role: "Photography",
          ig:"prolifikvisualz",
          name:"“ProlifiK P” The Content King"
        },
        {
          role: "Invitations",
          ig:"raquelkellykels",
          name:"Cousin Raquel Cobb"
        },
        {
          role: "Venue",
          name:"Kerry Smith First Class Venue"
        },
        {
          role: "Decorator",
          fb:"ExclusiveCreationzz",
          name:"Ketonnia Appling Exclusive Creationz"
        },
        {
          role: "Photography and Videography",
          fb:"marriedtomoneyent.mtm",
          name:"Married to Money Entertainment Willie Hall"
        },
        {
          role: "DJ and 360 Booth",
          fb:"profile.php?id=100083085949060",
          name:"MBK Entertainment"
        },
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
.hero {
  background-color: #f7fafd;
  .text-blog {
    min-height: 452px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    h2 {
      font-style: normal;
      font-weight: normal;
      font-size: 48px;
      line-height: 129.7%;
      color: #474d52;
      margin-bottom: 16px;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #474d52;
      margin-bottom: 24px;
    }
    .btn-outline {
      height: 35px;
      text-transform: capitalize;
      border: 1px solid #557efb;
      border-radius: 4px;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #557efb;
      padding: 8px 16px;
      &:hover {
        &:before,
        &:after {
          content: none;
        }

        background-color: #557efb;
        color: #fff;
      }
    }
  }
  .img-blog {
    min-height: 452px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media (max-width: 767px) {
  .hero {
    .text-blog {
      padding-top: 60px;
      min-height: unset;
    }
    .img-blog {
      margin-top: 60px;
      min-height: unset;
      img {
        max-height: 250px;
      }
    }
  }
}
</style>
